module.exports = __webpack_public_path__ + "img/medal.d9c6587a.png";